import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    direction: 'rtl',
    typography: {
        fontFamily: 'Rubik, sans-serif',
    },
});

export default theme;